const { DateTime, Settings, Duration, Interval } = require('luxon')
Settings.defaultLocale = 'en-AU'

DateTime.prototype.toSimpleSQL = function () {
  return this.toFormat('yyyy-LL-dd HH:mm:ss')
}

// Luxon does not show "Just Now" if the time is 0 seconds ago.
// Fixes: https://github.com/moment/luxon/issues/478
DateTime.prototype.fromNow = function (capitalise = false) {
  const relativeTime = this.toRelative()
  if (relativeTime === 'in 0 seconds' || relativeTime === '0 seconds ago') {
    return `${capitalise ? 'J' : 'j'}ust now`
  }
  return relativeTime
}

export const dateFormats = {
  DATE: 'dd-LL-yyyy',
  TIME: 'h:mma',
  TIME_24HR: 'HH:mm',
  TIME_SEC_24HR: 'HH:mm:ss',
  DATE_TIME: 'dd-LL-yyyy h:mma',
  DATE_TIME_SEC: 'dd-LL-yyyy h:mm:ssa',
  FRIENDLY_DATE: 'd LLLL yyyy',
  FRIENDLY_DATE_TIME: 'd LLLL yyyy, h:mma',
  FRIENDLY_SHORT_DATE: 'd LLL yyyy',
  FRIENDLY_SHORT_DATE_TIME: 'd LLL yyyy, h:mma',
  SHORT_WORDED_DATE: 'ccc, d LLL yyyy',
  SHORT_WORDED_DATE_TIME: 'ccc, d LLL yyyy, h:mma'
}

// leave the export, even if you don't use it
export default ({ app, store }) => {
  app.config.globalProperties.$formatDate = (value, format) => {
    if (!value) {
      return 'Invalid Date'
    }
    if (DateTime.isDateTime(value)) {
      return value.toFormat(format)
    }
    return DateTime.fromSQL(String(value)).toFormat(format)
  }

  app.config.globalProperties.$formatDateCustom = (value, format, givenFormat) => {
    if (!value) {
      return 'Invalid Date'
    }
    if (DateTime.isDateTime(value)) {
      return value.toFormat(format)
    }
    return DateTime.fromFormat(String(value), givenFormat).toFormat(format)
  }

  app.config.globalProperties.$formatSystemDate = (value, format, toTimezone = null, fromTimezone = process.env.SYSTEM_TIMEZONE) => {
    if (!value) {
      return 'Invalid Date'
    }
    if (DateTime.isDateTime(value)) {
      return 'Cannot use DateTime instance'
    }

    const timezone = toTimezone || store.getters['company/getCompany'].timezone
    return DateTime.fromSQL(String(value), { zone: fromTimezone })
      .setZone(timezone)
      .toFormat(format)
  }

  app.config.globalProperties.luxonFormats = dateFormats
  app.config.globalProperties.luxon = DateTime
  app.config.globalProperties.luxonDuration = Duration
  app.config.globalProperties.luxonInterval = Interval
}
